import React, { useEffect, useState } from 'react';
import { SnippetsOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

export default {
    Renderer: (props) => {
        const data = props.data

        return (
            <>
                {data.content && (
                    <div dangerouslySetInnerHTML={{__html:data.content}} style={{width: "100%"}}/>
                )}
            </>
        )

    },
    id: 'html-content',
    icon: <SnippetsOutlined />,
    version: 1,
    allowClickInside: true,
}